export default __webpack_public_path__ + "media/siteware/favicon-32-1c2a6db4f58d0c7ba3ca80d8b0a0cb3d.png";